const GET_CATEGORY_LIST_DATA = 'GET_CATEGORY_LIST_DATA';
const OPEN_EDITOR = 'CATEGORY_LIST_OPEN_EDITOR';
const CANCEL_EDIT = 'CATEGORY_LIST_CANCEL_EDIT';
const HANDLE_EDIT = 'CATEGORY_LIST_HANDLE_EDIT';
const OPEN_CREATE_MODAL = 'CATEGORY_LIST_OPEN_CREATE_MODAL';
const CANCEL_CREATE = 'CATEGORY_LIST_CANCEL_EDIT';
const HANDLE_CREATE = 'CATEGORY_LIST_HANDLE_CREATE';

export {
  GET_CATEGORY_LIST_DATA,
  OPEN_EDITOR,
  CANCEL_EDIT,
  HANDLE_EDIT,
  OPEN_CREATE_MODAL,
  CANCEL_CREATE,
  HANDLE_CREATE,
};
